import { render, staticRenderFns } from "./TradableSummary.vue?vue&type=template&id=324034d1"
import script from "./TradableSummary.vue?vue&type=script&lang=js"
export * from "./TradableSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports